/**
 * This function removes all invalid HTML characters from a string
 * and replaces them with a dash.
 */
export function removeInvalidHtmlCharacters(id: string) {
  return id.replace(/[^a-zA-Z0-9\-_:.]/g, "-")
}
